__turbopack_context__.v({
  "checkboxBox": "sales-contact-form-module__JQoXuG__checkboxBox",
  "checkboxBoxNew": "sales-contact-form-module__JQoXuG__checkboxBoxNew",
  "checkboxContainer": "sales-contact-form-module__JQoXuG__checkboxContainer",
  "checkboxContainerNew": "sales-contact-form-module__JQoXuG__checkboxContainerNew",
  "checkboxInput": "sales-contact-form-module__JQoXuG__checkboxInput",
  "checkboxLabel": "sales-contact-form-module__JQoXuG__checkboxLabel",
  "checkboxWrapper": "sales-contact-form-module__JQoXuG__checkboxWrapper",
  "comboboxButton": "sales-contact-form-module__JQoXuG__comboboxButton",
  "comboboxContainer": "sales-contact-form-module__JQoXuG__comboboxContainer",
  "comboboxRow": "sales-contact-form-module__JQoXuG__comboboxRow",
  "comboboxWrapper": "sales-contact-form-module__JQoXuG__comboboxWrapper",
  "error": "sales-contact-form-module__JQoXuG__error",
  "fieldGroup": "sales-contact-form-module__JQoXuG__fieldGroup",
  "form": "sales-contact-form-module__JQoXuG__form",
  "formContainer": "sales-contact-form-module__JQoXuG__formContainer",
  "fullWidthField": "sales-contact-form-module__JQoXuG__fullWidthField",
  "grid": "sales-contact-form-module__JQoXuG__grid",
  "headerEmailIcon": "sales-contact-form-module__JQoXuG__headerEmailIcon",
  "headerEmailLink": "sales-contact-form-module__JQoXuG__headerEmailLink",
  "headerEmailRow": "sales-contact-form-module__JQoXuG__headerEmailRow",
  "heading": "sales-contact-form-module__JQoXuG__heading",
  "headingContainer": "sales-contact-form-module__JQoXuG__headingContainer",
  "input": "sales-contact-form-module__JQoXuG__input",
  "inputError": "sales-contact-form-module__JQoXuG__inputError",
  "label": "sales-contact-form-module__JQoXuG__label",
  "lastRow": "sales-contact-form-module__JQoXuG__lastRow",
  "listbox": "sales-contact-form-module__JQoXuG__listbox",
  "listboxItem": "sales-contact-form-module__JQoXuG__listboxItem",
  "messageFieldGroup": "sales-contact-form-module__JQoXuG__messageFieldGroup",
  "messageTextarea": "sales-contact-form-module__JQoXuG__messageTextarea",
  "newFormComboboxButton": "sales-contact-form-module__JQoXuG__newFormComboboxButton",
  "newFormComboboxError": "sales-contact-form-module__JQoXuG__newFormComboboxError",
  "newFormComboboxInput": "sales-contact-form-module__JQoXuG__newFormComboboxInput",
  "newFormComboboxWrapper": "sales-contact-form-module__JQoXuG__newFormComboboxWrapper",
  "newFormFieldGroup": "sales-contact-form-module__JQoXuG__newFormFieldGroup",
  "newFormGrid": "sales-contact-form-module__JQoXuG__newFormGrid",
  "newFormHeading": "sales-contact-form-module__JQoXuG__newFormHeading",
  "newFormRow": "sales-contact-form-module__JQoXuG__newFormRow",
  "newFormRowFull": "sales-contact-form-module__JQoXuG__newFormRowFull",
  "newFormRowThree": "sales-contact-form-module__JQoXuG__newFormRowThree",
  "newFormRowTwo": "sales-contact-form-module__JQoXuG__newFormRowTwo",
  "newFormSection": "sales-contact-form-module__JQoXuG__newFormSection",
  "popover": "sales-contact-form-module__JQoXuG__popover",
  "recaptchaWrapper": "sales-contact-form-module__JQoXuG__recaptchaWrapper",
  "required": "sales-contact-form-module__JQoXuG__required",
  "row": "sales-contact-form-module__JQoXuG__row",
  "slideIn": "sales-contact-form-module__JQoXuG__slideIn",
  "statusError": "sales-contact-form-module__JQoXuG__statusError",
  "statusErrorAlert": "sales-contact-form-module__JQoXuG__statusErrorAlert",
  "statusErrorDismiss": "sales-contact-form-module__JQoXuG__statusErrorDismiss",
  "statusErrorIcon": "sales-contact-form-module__JQoXuG__statusErrorIcon",
  "statusErrorText": "sales-contact-form-module__JQoXuG__statusErrorText",
  "statusMessage": "sales-contact-form-module__JQoXuG__statusMessage",
  "statusSuccess": "sales-contact-form-module__JQoXuG__statusSuccess",
  "submitButton": "sales-contact-form-module__JQoXuG__submitButton",
  "submitWrapperDesktop": "sales-contact-form-module__JQoXuG__submitWrapperDesktop",
  "submitWrapperMobile": "sales-contact-form-module__JQoXuG__submitWrapperMobile",
  "successActions": "sales-contact-form-module__JQoXuG__successActions",
  "successContainer": "sales-contact-form-module__JQoXuG__successContainer",
  "successContent": "sales-contact-form-module__JQoXuG__successContent",
  "successIcon": "sales-contact-form-module__JQoXuG__successIcon",
  "successMessage": "sales-contact-form-module__JQoXuG__successMessage",
  "textarea": "sales-contact-form-module__JQoXuG__textarea",
});
